import Widget from "./Widget";
import { Skeleton } from "@src/lib/ui/Skeleton";
import StarOutlineIcon from "@src/lib/icons/18px/star-outline";
import Text from "@src/lib/ui/Text";
import EmptyWidgetContent from "./EmptyWidgetContent";
import { useAverageCourseFeedbackQuery } from "@src/features/home/AvgTrainingFeedbackWidget.generated";
import AvgTrainingFeedbackChart from "@src/features/home/AvgTrainingFeedbackChart";
import { gql } from "@apollo/client";

const AvgTrainingFeedbackWidget: React.FC = () => {
  const { data, loading } = useAverageCourseFeedbackQuery({
    variables: {
      input: {},
    },
  });
  const average = data?.AverageCourseFeedback || 0;

  if (!loading && average === 0) {
    return (
      <Widget title="Average Training Feedback" Icon={StarOutlineIcon}>
        {!loading && !average && (
          <EmptyWidgetContent
            illustration={
              <StarOutlineIcon className="size-8 text-muted-foreground" />
            }
            description="You'll be able to identify feedback trends here"
          />
        )}
      </Widget>
    );
  }
  return (
    <Widget
      title="Average Training Feedback"
      Icon={StarOutlineIcon}
      href={{ pathname: "/reporting/course-feedback" }}
    >
      {loading ? (
        <div>
          {loading && <Skeleton className="h-10 w-20 rounded-md" />}
          {loading && <Skeleton className="mt-5 h-[250px] w-full rounded-xl" />}
        </div>
      ) : (
        <div>
          <div className="flex items-baseline gap-1">
            <Text variant="display-bold">{average.toFixed(1)}</Text>
            <Text variant="fine-print-title" className="text-gray-7">
              out of 5
            </Text>
          </div>
          <AvgTrainingFeedbackChart />
        </div>
      )}
    </Widget>
  );
};

export default AvgTrainingFeedbackWidget;

gql`
  query AverageCourseFeedback($input: CourseFeedbacksInput!) {
    AverageCourseFeedback(input: $input)
  }
`;
